<script>
  // Перенос MetricGrid из lib/ui.tsx.
  let className = '';
  export { className as class };
  export let style = undefined;
</script>

<div class={'ui-mgrid' + (className ? ' ' + className : '')} {style}><slot /></div>
